module.exports = __webpack_public_path__ + "img/ios-qr.d5df8413.png";